import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { handleAPIError } from '../../errors';
import { errorMessage } from './constants';

/**
 * Delete user saved project
 * @param {String} userSavedId
 * @returns {Promise<{void}>}
 */
const deleteUserSavedProject = async (userSavedId) => {
    const requestUrl = pathfinder('logo_maker_makers_delete_user_saved_project', { savedProjectId: userSavedId });

    try {
        await axios.delete(requestUrl);
    } catch (e) {
        handleAPIError(e, errorMessage);
    }
};

export default deleteUserSavedProject;
